var _rect, _g, _path, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsSpecialOffer = function SvgSmsSpecialOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 76,
    fill: "none",
    viewBox: "0 0 120 76"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2351_5454",
    width: 120,
    height: 76,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 74,
    x: 1,
    y: 1,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2351_5454)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2351_5454)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2351_5454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2351_5454",
    width: 121,
    height: 76,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M119.5 0H-0.5V76H119.5V0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2351_5454)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M119.5 0H-0.5V76H119.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6937",
    d: "M95.5 0H24.83V49H95.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6937",
    d: "M25.5 48H-0.5V76H25.5V48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6937",
    d: "M111.5 48H95.5V76H111.5V48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0BFF8",
    d: "M111.5 0H95.5V48H111.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M96.83 -0.328125H95.5V77.0019H96.83V-0.328125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A3E8",
    d: "M-0.5 -0.328125H24.83V23.6719H-0.5V-0.328125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3.16997 23.6719H1.83997V-0.328125H3.16997V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7.16997 23.6719H5.83997V-0.328125H7.16997V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10.83 23.6719H9.5V-0.328125H10.83V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14.83 23.6719H13.5V-0.328125H14.83V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18.83 23.6719H17.5V-0.328125H18.83V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M22.4999 23.6719H21.1699V-0.328125H22.4999V23.6719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0BFF8",
    d: "M25.83 49H95.5V76.33H25.83V49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M28.28 77.3331H26.37L25.83 76.8131V74.9531L28.27 77.3431L28.28 77.3331Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M36.89 77.333H34.98L25.83 68.403V66.543L36.89 77.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M45.8 77.3316H43.89L25.84 59.7116V57.8516L45.8 77.3416V77.3316Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M54.65 77.3309H52.74L25.83 51.0709V49.2109L54.65 77.3409V77.3309Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M63.4999 77.33H61.5899L32.5599 49H34.4699L63.4999 77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M72.02 77.33H70.11L41.08 49H42.99L72.02 77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M80.8699 77.33H78.9599L49.9299 49H51.8399L80.8699 77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M89.7299 77.33H87.8199L58.7899 49H60.6999L89.7299 77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M95.4999 74.33V76.19L67.6399 49H69.5499L95.4999 74.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M95.5 65.6822V67.5422L76.5 48.9922H78.41L95.5 65.6722V65.6822Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M95.5 57.04V58.9L85.35 49H87.26L95.5 57.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M95.5 50.26L94.21 49H95.5V50.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E54B7",
    d: "M-5.17004 38C-5.17004 35.79 -3.38004 34 -1.17004 34H23.64C25.85 34 27.64 35.79 27.64 38V88.33C27.64 90.54 25.85 92.33 23.64 92.33H-1.17004C-3.38004 92.33 -5.17004 90.54 -5.17004 88.33V38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2.12 34H20.35V37.19C20.35 38.11 19.6 38.86 18.68 38.86H3.79C2.87 38.86 2.12 38.11 2.12 37.19V34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23.65 92.33H-1.17004C-3.38004 92.33 -5.17004 90.54 -5.17004 88.33V38C-5.17004 35.79 -3.38004 34 -1.17004 34H2.11996H23.64C25.85 34 27.64 35.79 27.64 38V88.33C27.64 90.54 25.85 92.33 23.64 92.33H23.65ZM-1.17004 35C-2.82004 35 -4.17004 36.35 -4.17004 38V88.33C-4.17004 89.98 -2.82004 91.33 -1.17004 91.33H23.64C25.29 91.33 26.64 89.98 26.64 88.33V38C26.64 36.35 25.29 35 23.64 35H21.35V37.19C21.35 38.66 20.15 39.86 18.68 39.86H3.78996C2.31996 39.86 1.11996 38.66 1.11996 37.19V35H-1.17004ZM3.11996 35V37.19C3.11996 37.56 3.41996 37.86 3.78996 37.86H18.69C19.06 37.86 19.36 37.56 19.36 37.19V35H3.11996ZM18.38 88.17H5.31996C4.56996 88.17 3.94996 87.61 3.86996 86.86V86.71V86.59C3.94996 85.82 4.56996 85.26 5.31996 85.26H18.38C19.18 85.26 19.84 85.91 19.84 86.72C19.84 87.53 19.19 88.18 18.38 88.18V88.17ZM4.85996 86.71V86.79C4.88996 87 5.07996 87.17 5.31996 87.17H18.38C18.63 87.17 18.84 86.97 18.84 86.71C18.84 86.45 18.64 86.25 18.38 86.25H5.31996C5.08996 86.25 4.88996 86.43 4.86996 86.66V86.7L4.85996 86.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M94.27 11.332C98.6899 11.332 102.27 14.912 102.27 19.332V53.812C102.27 58.232 98.6899 61.812 94.27 61.812H45.61C41.22 62.102 34.8 62.702 30.92 63.722C26.05 64.992 22.16 69.332 20.83 71.342V19.332C20.83 14.912 24.41 11.332 28.83 11.332H94.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M92.27 9.67188C96.6899 9.67188 100.27 13.2519 100.27 17.6719V52.1519C100.27 56.5719 96.6899 60.1519 92.27 60.1519H43.61C39.22 60.4419 32.8 61.0419 28.92 62.0619C24.05 63.3319 20.16 67.6719 18.83 69.6819V17.6719C18.83 13.2519 22.41 9.67188 26.83 9.67188H92.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18.8299 70.33C18.7699 70.33 18.6999 70.33 18.6399 70.3C18.3599 70.22 18.1699 69.96 18.1699 69.66V17.67C18.1699 12.89 22.0599 9 26.8399 9H92.2799C97.0599 9 100.95 12.89 100.95 17.67V52.15C100.95 56.93 97.0599 60.82 92.2799 60.82H43.6399C40.6899 61.01 33.4099 61.58 29.0999 62.7C24.4799 63.9 20.7299 68.03 19.3899 70.04C19.2599 70.23 19.0499 70.34 18.8299 70.34V70.33ZM26.8299 10.33C22.7899 10.33 19.4999 13.62 19.4999 17.66V67.69C21.4399 65.42 24.7899 62.43 28.7599 61.39C33.1899 60.24 40.5899 59.66 43.5699 59.46C43.5799 59.46 43.5999 59.46 43.6099 59.46H92.2699C96.3099 59.46 99.5999 56.17 99.5999 52.13V17.67C99.5999 13.63 96.3099 10.34 92.2699 10.34H26.8299V10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M43.63 33.0622C43.56 32.3722 43.27 31.8322 42.74 31.4422C42.22 31.0622 41.51 30.8622 40.61 30.8622C40 30.8622 39.49 30.9522 39.07 31.1222C38.65 31.2922 38.33 31.5222 38.11 31.8222C37.89 32.1222 37.78 32.4622 37.78 32.8422C37.77 33.1622 37.83 33.4322 37.98 33.6722C38.13 33.9122 38.33 34.1122 38.59 34.2822C38.85 34.4522 39.15 34.5922 39.49 34.7222C39.83 34.8422 40.19 34.9422 40.57 35.0322L42.15 35.4122C42.92 35.5822 43.62 35.8122 44.27 36.1022C44.91 36.3922 45.47 36.7422 45.94 37.1622C46.41 37.5822 46.77 38.0722 47.03 38.6422C47.29 39.2122 47.43 39.8622 47.43 40.5922C47.43 41.6722 47.15 42.6022 46.6 43.4022C46.06 44.1922 45.28 44.8022 44.26 45.2322C43.24 45.6622 42.02 45.8822 40.59 45.8822C39.16 45.8822 37.93 45.6622 36.87 45.2322C35.82 44.7922 35 44.1522 34.41 43.2922C33.83 42.4322 33.52 41.3722 33.49 40.1022H37.1C37.14 40.6922 37.31 41.1822 37.61 41.5822C37.91 41.9722 38.32 42.2722 38.82 42.4722C39.33 42.6722 39.91 42.7622 40.55 42.7622C41.19 42.7622 41.73 42.6722 42.19 42.4822C42.66 42.3022 43.02 42.0422 43.28 41.7122C43.54 41.3822 43.67 41.0122 43.67 40.5822C43.67 40.1822 43.55 39.8522 43.32 39.5822C43.09 39.3122 42.75 39.0822 42.3 38.8922C41.86 38.7022 41.32 38.5322 40.67 38.3722L38.75 37.8922C37.26 37.5322 36.09 36.9622 35.23 36.1922C34.37 35.4222 33.94 34.3922 33.95 33.0822C33.95 32.0122 34.23 31.0822 34.8 30.2822C35.38 29.4822 36.17 28.8622 37.18 28.4122C38.19 27.9622 39.34 27.7422 40.62 27.7422C41.9 27.7422 43.07 27.9622 44.05 28.4122C45.03 28.8622 45.79 29.4822 46.34 30.2822C46.89 31.0822 47.17 32.0022 47.18 33.0522H43.61L43.63 33.0622Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M49.9499 27.9905H54.5399L59.3899 39.8305H59.5999L64.4499 27.9905H69.0399V45.6105H65.4299V34.1405H65.2799L60.7199 45.5205H58.2599L53.6999 34.0905H53.5499V45.6005H49.9399V27.9805L49.9499 27.9905Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M81.6799 33.0622C81.6099 32.3722 81.3199 31.8322 80.7899 31.4422C80.2699 31.0622 79.5599 30.8622 78.6599 30.8622C78.0499 30.8622 77.5399 30.9522 77.1199 31.1222C76.6999 31.2922 76.3799 31.5222 76.1599 31.8222C75.9399 32.1222 75.8299 32.4622 75.8299 32.8422C75.8199 33.1622 75.8799 33.4322 76.0299 33.6722C76.1799 33.9122 76.3799 34.1122 76.6399 34.2822C76.8999 34.4522 77.1999 34.5922 77.5299 34.7222C77.8699 34.8422 78.2299 34.9422 78.6099 35.0322L80.1899 35.4122C80.9599 35.5822 81.6599 35.8122 82.3099 36.1022C82.9499 36.3922 83.5099 36.7422 83.9799 37.1622C84.4499 37.5822 84.8099 38.0722 85.0699 38.6422C85.3299 39.2122 85.4699 39.8622 85.4699 40.5922C85.4699 41.6722 85.1899 42.6022 84.6399 43.4022C84.0999 44.1922 83.3199 44.8022 82.2999 45.2322C81.2799 45.6622 80.0599 45.8822 78.6299 45.8822C77.1999 45.8822 75.9699 45.6622 74.9099 45.2322C73.8599 44.7922 73.0399 44.1522 72.4499 43.2922C71.8599 42.4322 71.5599 41.3722 71.5299 40.1022H75.1399C75.1799 40.6922 75.3499 41.1822 75.6499 41.5822C75.9499 41.9722 76.3599 42.2722 76.8599 42.4722C77.3699 42.6722 77.9499 42.7622 78.5899 42.7622C79.2299 42.7622 79.7699 42.6722 80.2299 42.4822C80.6999 42.3022 81.0599 42.0422 81.3199 41.7122C81.5799 41.3822 81.7099 41.0122 81.7099 40.5822C81.7099 40.1822 81.5899 39.8522 81.3599 39.5822C81.1299 39.3122 80.7899 39.0822 80.3399 38.8922C79.8999 38.7022 79.3599 38.5322 78.7099 38.3722L76.7899 37.8922C75.2999 37.5322 74.1299 36.9622 73.2699 36.1922C72.4099 35.4222 71.9799 34.3922 71.9899 33.0822C71.9899 32.0122 72.2699 31.0822 72.8399 30.2822C73.4199 29.4822 74.2099 28.8622 75.2199 28.4122C76.2299 27.9622 77.3799 27.7422 78.6599 27.7422C79.9399 27.7422 81.1099 27.9622 82.0799 28.4122C83.0599 28.8622 83.8199 29.4822 84.3699 30.2822C84.9099 31.0822 85.1999 32.0022 85.2099 33.0522H81.6399L81.6799 33.0622Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M119.5 0H111.5V76H119.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M112.16 0H110.83V76.33H112.16V0Z"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 74,
    x: 1,
    y: 1,
    stroke: "black",
    strokeWidth: 2,
    rx: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2351_5454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    fill: "white",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2351_5454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    fill: "white",
    transform: "translate(-0.5)"
  })))));
};
export default SvgSmsSpecialOffer;